<template>
  <div class="eventPrecautionForJoin">
    <template v-if="hasHtml">
      <div v-html="precautionHtml"></div>
    </template>
    <template v-else>
      <em>
        【必ず事前にご確認ください。】<br />
        ご参加にはZoomアプリのインストールが必要になります。</em
      ><br />
      イベント開催前に、<TextLink
        blank
        :hasArrow="false"
        text="こちらのリンク"
        link="https://zoom.us/download#client_4meeting"
      />
      からダウンロードおよびインストールをお願いします。<br />
      ※zoomご利用環境について
      <TextLink
        blank
        :hasArrow="false"
        text="PCご利用の場合"
        link="https://support.zoom.us/hc/ja/articles/201362023"
      />
      |
      <TextLink
        blank
        :hasArrow="false"
        text="スマホ・タブレットご利用の場合"
        link="https://support.zoom.us/hc/ja/articles/201179966"
      />
    </template>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import TextLink from '@/components/elements/TextLink.vue'

export default defineComponent({
  name: 'EventPrecautionForJoin',
  components: {
    TextLink
  },
  props: {
    precautionHtml: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    return {
      hasHtml: props.precautionHtml !== ''
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;
.eventPrecautionForJoin {
  padding: 10px 15px;
  line-height: 1.78;
  border: 1px solid var.$color-red;
  em {
    color: var.$color-red;
    font-style: normal;
  }
}
</style>
